import {combineReducers} from 'redux'

import storageReducer from './storageReducer'
import navigationReducer from './navigationReducer'

export default combineReducers({
	storage: storageReducer,
	navigation: navigationReducer
})